// extracted by mini-css-extract-plugin
export default {"Overview":"Overview-module__Overview--pcjoK","Cell":"Overview-module__Cell--bllsI","Description":"Overview-module__Description--x20AP"};